"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = groupAndSortPackages;
function groupAndSortPackages(packageOptions) {
    const map = new Map();
    for (const opt of packageOptions) {
        const roomId = opt.package.roomType?.id ?? '';
        const arr = map.get(roomId) || [];
        arr.push(opt);
        map.set(roomId, arr);
    }
    const rooms = [];
    for (const [roomId, views] of map.entries()) {
        views.sort((a, b) => a.hotelPrice - b.hotelPrice);
        rooms.push({ roomId, packageDetails: views });
    }
    rooms.sort((a, b) => (a.packageDetails[0]?.hotelPrice ?? 0) - (b.packageDetails[0]?.hotelPrice ?? 0));
    return rooms;
}
